module.exports = __webpack_public_path__ + "static/media/home1.99a18d77.png";